import React from 'react';
import {
  Container,
  Row,
  Card,
  Col,
  Button,
  Nav,
  OverlayTrigger,
  Tooltip,
  Form,
} from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import { useEffect } from 'react';
import { useState } from 'react';
import ActionRequestService from '../../services/action-request';
import ResalesRequestService from '../../services/resales-request';
import { WidgetsOutlined, Add, ArrowBackIos } from '@material-ui/icons';
import ActionList from './List';
import styles from './style.module.scss';
import { FundType } from '../../helpers/Enum/index';
import { collect } from 'collect.js';
import Can from 'components/Can';
import './style.css';
import SelectFiscalYears from 'components/SelectFiscalYears';
import { useHistory } from 'react-router-dom';
import { getCurrentFiscalYear } from 'helpers/FiscalYearHelper';
import { useCompany, useUser } from 'models';

export default function(){
  const user = useUser()
  const {company:currentCompany} = useCompany()

  const [flow, setFlow] = useState(null);
  const [status, setStatus] = useState([]);
  const [actions, setActions] = useState([]);

  const [flowSelected, setFlowSelected] = useState(1);
  const [countActions, setCountActions] = useState([]);

  //const [fiscalYear, setFiscalYear] = useState(getCurrentFiscalYear());
  // const [fiscalYear, setFiscalYear] = useState(
  //   currentCompany ? 
  //   currentCompany.fiscal_years_elite.length == currentCompany.all_company_fiscal_years.length ? 
  //   user.area.fiscal_year.id :
  //   currentCompany.fiscal_years_elite[currentCompany.fiscal_years_elite.length - 1].id :
  //   user.area.fiscal_year.id
  // )

  const [fiscalYear, setFiscalYear] = useState(10)

  const [companyId, setCompanyId] = useState(
    currentCompany
      ? currentCompany.id
      :  user.company ? user.company.id : '');

  const history = useHistory();

  useEffect(() => {
    changeFiscalYear(fiscalYear);
    getFlows();
    getActions();
  }, []);

  const getFlows = () => {
    let request = ActionRequestService.getFlow(2);
    request.then((data) => {
      let r = data.data.data;
      r.user_steps = [];
      // user.profiles.forEach((profile) => {
      //   if (profile.steps)
      //     profile.steps.forEach((step) => {
      //       if (r.id == step.flow_id) {
      //         r.user_steps[step.id] = step;
      //       }
      //     });
      // });
      setFlow(r);
      setStatus(Object.values(r.action_status));
    });
  };

  const getProfile = () => {
    return localStorage.getItem('profile');
  };

  const getActions = (fiscal_year_id = null, company_id = null) => {
    var filter = {
      fiscal_year_id: fiscal_year_id ?? fiscalYear,
      __type_id: FundType().Rebate,
      company_id: company_id ?? companyId
    };

    ActionRequestService.amountByStatus({ params: { ...filter } })
    .then((data) => {
      setCountActions(data.data.data);
    });
  };
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Período de bloqueio para solicitação de novos resgates. A partir do dia
      primeiro do mês seguinte o sistema será reaberto para novas solicitações.
      Dúvidas consulte a seção de Perguntas e Respostas (FAQ).
    </Tooltip>
  );

  const getDay = () => {
    let a = new Date();
    return a.getDate();
  };

  const changeFiscalYear = (id) => {
    const filter = {
      fiscal_year_id: id
    };
    if(currentCompany){
      filter.company_id = currentCompany
        ? currentCompany.id
        : user.currentCompany.id;
        
      let companies = ResalesRequestService.getGroupHeadquarter({
        params: { ...filter },
      });
      companies.then((data) => {
        let c = data.data.data;
        setCompanyId(data.data.data.company_id)
        setFiscalYear(id);
        getActions(parseInt(id), c.company_id);
      });
    }else{
      setFiscalYear(id);
      getActions(parseInt(id))
    }
  }

  return (
    <>
      <Container>
        <Row className="mt-4">
          <Button variant="link" className="link-back" onClick={() => history.goBack()}>
            <ArrowBackIos className="icon-title icon-back" />
            <h6 className="font-13 mt-3">Voltar</h6>
          </Button>
        </Row>
        <Row className="mt-4 d-flex align-items-end">
          <Col className="d-flex">
            <WidgetsOutlined className="icon-title" />
            <h5 className="title-dashboard">Fluxo de Rebate</h5>
          </Col>
          <Col className="d-flex flex-column">
            <small className="text-right">Vigência Fundos FY22: 01/07/2021 a 30/06/2022</small>
            <small className="text-right">Após o término da Campanha em 30 de Junho de 2022 os Fundos</small>
            <small className="text-right">não resgatados serão expirados em 60 dias (20/08/2022) automaticamente.</small>
          </Col>
        </Row>
        <Row>
          <Card.Body className="card-dashboard shadow bg-white rounded text-center m-2 col-12">
            <Row className="mt-2 mb-3">
              {/* {currentCompany ? (
                currentCompany.fiscal_years_elite.length > 1 || (currentCompany.group_years && currentCompany.group_years.length > 1) ?
                  <Col md="2">
                    <Form.Control
                      as="select"
                      value={fiscalYear}
                      onChange={(e) => changeFiscalYear(e.target.value)}
                      className="font-12"
                    >
                      <SelectFiscalYears company={currentCompany}/>
                    </Form.Control>
                  </Col>
                  : ''
              ) : (
                  <Col xs='12' md="2" className="mt-2">
                    <Form.Control
                      as="select"
                      value={fiscalYear}
                      onChange={(e) => changeFiscalYear(e.target.value)}
                      className="font-12"
                    >
                      <SelectFiscalYears/>
                    </Form.Control>
                  </Col>
                )} */}
            </Row>
            <Nav
              className="nav nav-pills navtab-bg nav-justified nav-actions"
              defaultActiveKey="1"
              onSelect={(selectedKey) => setFlowSelected(selectedKey)}
            >
              {status.map((item, k) => {
                return (
                  <Nav.Item key={k} className="nav-item-actions">
                    <Nav.Link
                      data-toggle="tab"
                      aria-expanded="false"
                      className={
                        'nav-item-actions-btn btn nav-link' + flowSelected ===
                          item.id
                          ? ' active'
                          : ''
                      }
                      eventKey={item.id}
                    >
                      {item.name}
                    </Nav.Link>
                    <span
                      className={
                        'badge badge-pill float-right ' + styles.countspan
                      }
                    >
                      {countActions[item.id] ? countActions[item.id].amount : 0}
                    </span>
                  </Nav.Item>
                );
              })}
            </Nav>

            <ActionList
              user={user}
              currentCompany={currentCompany}
              flowSelected={flowSelected}
              fiscalYear={fiscalYear}
              companyId={companyId}
            />
          </Card.Body>
        </Row>
      </Container>
    </>
  );
};
